"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Svg = _interopRequireDefault(require("../Svg/Svg"));
var _Tooltip = _interopRequireDefault(require("../Tooltip/Tooltip"));
var _constants = require("../constants");
var Pill = function Pill(_ref) {
  var pill = _ref.pill,
    title = _ref.title,
    icon = _ref.icon,
    iconcolor = _ref.iconcolor,
    size = _ref.size,
    type = _ref.type,
    isAngular = _ref.isAngular,
    className = _ref.className,
    iconFlip = _ref.iconFlip,
    iconBig = _ref.iconBig,
    tooltip = _ref.tooltip;
  var DefaultPill = function DefaultPill() {
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: (0, _classnames["default"])(className, 'pill', !iconcolor && !type && 'pill--standard', type, 'inline-flex', 'items-center', 'd8-u-color-white', size || 'pill--sm', isAngular && 'is-angular'),
      style: {
        backgroundColor: iconcolor
      }
    }, icon && !iconFlip && /*#__PURE__*/_react["default"].createElement(_Svg["default"], {
      className: iconBig ? 'icon--sm margin-right-xs' : 'icon--xs margin-right-xs',
      name: icon,
      fill: _constants.COLORS.WHITE
    }), pill || title, icon && iconFlip && /*#__PURE__*/_react["default"].createElement(_Svg["default"], {
      className: iconBig ? 'icon--sm margin-left-xs' : 'icon--xs margin-left-xs',
      name: icon,
      fill: _constants.COLORS.WHITE
    }), tooltip && /*#__PURE__*/_react["default"].createElement(_Svg["default"], {
      className: iconBig ? 'icon--sm margin-left-xs' : 'icon--xs margin-left-xs',
      name: "info-i-fill",
      fill: _constants.COLORS.WHITE
    }));
  };
  switch (pill) {
    case 'Sold out':
      return /*#__PURE__*/_react["default"].createElement("span", {
        className: "pill pill--sm pill--sold-out margin-top-xs inline-flex margin-left-sm"
      }, /*#__PURE__*/_react["default"].createElement(_Svg["default"], {
        className: "icon--xs margin-right-xs",
        name: "ban",
        fill: _constants.COLORS.WHITE
      }), "Sold out");
    case 'Coming soon':
      return /*#__PURE__*/_react["default"].createElement("span", {
        className: "pill pill--sm pill--coming-soon margin-top-xs inline-flex margin-left-sm"
      }, /*#__PURE__*/_react["default"].createElement(_Svg["default"], {
        className: "icon--xs margin-right-xs",
        name: "flame",
        fill: _constants.COLORS.WHITE
      }), "Coming soon");
    case 'Postponed':
      return /*#__PURE__*/_react["default"].createElement("span", {
        className: "pill pill--sm pill--orange margin-top-xs inline-flex margin-left-sm"
      }, /*#__PURE__*/_react["default"].createElement(_Svg["default"], {
        className: "icon--xs margin-right-xs",
        name: "ban",
        fill: _constants.COLORS.WHITE
      }), "Postponed");
    case 'AC':
      return /*#__PURE__*/_react["default"].createElement("span", {
        className: "pill pill--sm pill--light-blue margin-top-xs inline-flex margin-left-sm"
      }, /*#__PURE__*/_react["default"].createElement(_Svg["default"], {
        className: "icon--xs margin-right-xs",
        name: "ac",
        fill: _constants.COLORS.WHITE
      }), "A/C");
    case 'Popular':
      return /*#__PURE__*/_react["default"].createElement("span", {
        className: "pill pill--sm pill--primary margin-top-xs inline-flex margin-left-sm"
      }, /*#__PURE__*/_react["default"].createElement(_Svg["default"], {
        className: "icon--xs margin-right-xs",
        name: "flash",
        fill: _constants.COLORS.WHITE
      }), "Popular");
    case 'Best value':
      return /*#__PURE__*/_react["default"].createElement("span", {
        className: "pill pill--sm pill--primary margin-top-xs inline-flex margin-left-sm"
      }, /*#__PURE__*/_react["default"].createElement(_Svg["default"], {
        className: "icon--xs margin-right-xs",
        name: "dollar",
        fill: _constants.COLORS.WHITE
      }), "Best value");
    case 'Flexible':
      return /*#__PURE__*/_react["default"].createElement("span", {
        className: "pill pill--sm pill--standard margin-top-xs inline-flex margin-left-sm"
      }, /*#__PURE__*/_react["default"].createElement(_Svg["default"], {
        className: "icon--xs margin-right-xs",
        name: "shield-check",
        fill: _constants.COLORS.WHITE
      }), "Flexible");
    case 'Premium Plus':
      return /*#__PURE__*/_react["default"].createElement("span", {
        className: "pill pill--sm pill--catered margin-top-xs inline-flex margin-left-sm"
      }, "Premium +");
    case 'Not available':
      return /*#__PURE__*/_react["default"].createElement("span", {
        className: "pill pill--sm pill--black margin-top-xs inline-flex margin-left-sm"
      }, "Not available");
    default:
      if (tooltip) {
        return /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
          title: tooltip
        }, /*#__PURE__*/_react["default"].createElement(DefaultPill, null));
      }
      return /*#__PURE__*/_react["default"].createElement(DefaultPill, null);
  }
};
Pill.propTypes = {
  pill: _propTypes["default"].string,
  title: _propTypes["default"].string,
  icon: _propTypes["default"].string,
  iconcolor: _propTypes["default"].string,
  size: _propTypes["default"].string,
  type: _propTypes["default"].string,
  className: _propTypes["default"].string,
  isAngular: _propTypes["default"].bool,
  iconFlip: _propTypes["default"].bool,
  iconBig: _propTypes["default"].bool,
  tooltip: _propTypes["default"].string
};
var _default = exports["default"] = Pill;